/*
 * Validation message constants
 * As provided by Kate (Content) as generic content, modified slightly for technical application.
 *
 * https://akqainc-my.sharepoint.com/:x:/g/personal/hamish_lamb_akqa_com/EZJ8E8fIDvlBnWZUcX8Mm20BOtXzAcu8jV6sOp-3zuFXxg?e=s4DS5f
 *
 *
 * Validity conditions:
 *
 * badInput: Value is a string instead of number (ie 'eight' instead of 8)
 * patternMismatch: Value does not match pattern regex (ie password),
 * rangeOverflow: Value exceeds max attribute (number value),
 * rangeUnderflow: Value does not meet min attribute (number value),
 * stepMismatch: Value does not meet step attribute (not a multiple of step),
 * tooLong: Value length exceeds maxlength attribute,
 * tooShort: Value length does not meet minlength attribute,
 * typeMismatch: Email or URL is not correct format,
 * valueMissing: No value in a required field,
 *
 */

const validationMessages = {
    // Generic validation constants
    badInput: "You must enter a value in the suggested format.",
    patternMismatch: "This field does not match the suggested format.",
    rangeOverflow: "Please enter a number within the suggested range.",
    rangeUnderflow: "Please enter a number within the suggested range.",
    stepMismatch: "Please enter a number in the suggested format",
    tooLong: "This field must be within the suggested character range.",
    tooShort: "This field must be within the suggested character range.",
    // typeMismatch: 'Please enter a valid value.',
    // typeMismatch: 'Your value does not match the expected format.',
    typeMismatch: "This field does not match the expected format.",
    valueMissing: "Is required.",
    fields: {
        input: {
            // Input type specific validation constants
            text: {
                badInput: null,
                patternMismatch: null,
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: false,
                tooLong: null,
                tooShort: null,
                typeMismatch: null,
                valueMissing: null,
            },
            search: {
                badInput: null,
                patternMismatch: null,
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: false,
                tooLong: null,
                tooShort: null,
                typeMismatch: null,
                valueMissing: "Please enter a search term.",
            },
            tel: {
                // unsure if badInput is ever called on tel
                badInput: "Please enter a valid phone number.",
                patternMismatch: "Please enter a valid phone number.",
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: false,
                tooLong: null,
                tooShort: null,
                typeMismatch: null,
                valueMissing: "Please enter a phone number.",
            },
            url: {
                badInput: null,
                patternMismatch: "Please enter a valid URL.",
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: false,
                tooLong: null,
                tooShort: null,
                typeMismatch: "Please enter a valid URL.",
                valueMissing: null,
            },
            email: {
                badInput: null,
                patternMismatch: "Invalid email.",
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: false,
                tooLong: null,
                tooShort: null,
                typeMismatch: "Invalid email.",
                valueMissing: null,
            },
            password: {
                badInput: null,
                patternMismatch:
                    "This password does not match the expected format.",
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: false,
                tooLong: null,
                tooShort: null,
                typeMismatch:
                    "This password does not match the expected format.",
                valueMissing: null,
            },
            date: {
                badInput: null,
                patternMismatch: null,
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: false,
                tooLong: null,
                tooShort: null,
                typeMismatch: "This date does not match the suggested format.",
                valueMissing: null,
            },
            month: {
                badInput: null,
                patternMismatch: null,
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: false,
                tooLong: null,
                tooShort: null,
                typeMismatch: null,
                valueMissing: null,
            },
            week: {
                badInput: null,
                patternMismatch: null,
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: false,
                tooLong: null,
                tooShort: null,
                typeMismatch: null,
                valueMissing: null,
            },
            time: {
                badInput: null,
                patternMismatch: null,
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: false,
                tooLong: null,
                tooShort: null,
                typeMismatch: null,
                valueMissing: null,
            },
            file: {
                badInput: null,
                patternMismatch: null,
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: false,
                tooLong: null,
                tooShort: null,
                typeMismatch: null,
                valueMissing: null,
            },
            "datetime-local": {
                badInput: null,
                patternMismatch: null,
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: false,
                tooLong: null,
                tooShort: null,
                typeMismatch: null,
                valueMissing: null,
            },
            number: {
                badInput: "Please enter a valid number.",
                patternMismatch: null,
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: false,
                tooLong: null,
                tooShort: null,
                typeMismatch: "Please enter a valid number.",
                valueMissing: null,
            },
            color: {
                badInput: null,
                patternMismatch: null,
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: false,
                tooLong: null,
                tooShort: null,
                typeMismatch: null,
                valueMissing: null,
            },
            textarea: {
                badInput: null,
                customError: null,
                patternMismatch: null,
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: null,
                tooLong: null,
                tooShort: null,
                typeMismatch: null,
                valueMissing: null,
            },
            checkbox: {
                badInput: null,
                customError: null,
                patternMismatch: null,
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: null,
                tooLong: null,
                tooShort: null,
                typeMismatch: null,
                valueMissing: null,
            },
            radio: {
                badInput: null,
                customError: null,
                patternMismatch: null,
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: null,
                tooLong: null,
                tooShort: null,
                typeMismatch: null,
                valueMissing: null,
            },
            select: {
                badInput: null,
                customError: null,
                patternMismatch: null,
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: null,
                tooLong: null,
                tooShort: null,
                typeMismatch: null,
                valueMissing: null,
            },
            inputConfirm: {
                badInput: null,
                customError: null,
                patternMismatch: "These fields do not match",
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: null,
                tooLong: null,
                tooShort: null,
                typeMismatch: null,
                valueMissing: null,
            },
            alphanumeric: {
                badInput: null,
                customError: null,
                patternMismatch: "Please enter a valid alphanumeric value",
                rangeOverflow: null,
                rangeUnderflow: null,
                stepMismatch: null,
                tooLong: null,
                tooShort: null,
                typeMismatch: null,
                valueMissing: null,
            },
        },
    },
};

export default validationMessages;
